import { Dispatch, SetStateAction } from 'react';
import { InvoicesParams } from 'types/invoices';

export type FiltersProps = {
  setParams: Dispatch<SetStateAction<InvoicesParams>>;
  params: InvoicesParams;
};

export interface IFilters {
  startDate: Date;
  endDate: Date;
  np: boolean;
  status?: PaymentStatus | undefined;
  invoiceStatus?: InvoiceStatus | undefined;
  filterText?: string;
}

export enum InvoiceStatus {
  ALL = 'ALL',
  EXPORTED = 'EXPORTED',
  PUBLISHED = 'READY',
  NOT_PUBLISHED = 'DRAFT',
}

export enum PaymentStatus {
  ALL = 'ALL',
  PAID = 'PAID',
  REQUIRE_PAYMENT = 'NOT_PAID',
}

export enum AllocationStatus {
  ALL = 'ALL',
  PARTIAL = 'PARTIAL', // częsciowo zaalokowana
  INITIAL = 'INITIAL', // w trakcie
  FULLY_ALLOCATED = 'FULL', // całkowicie zaalokowana
  ACCEPTED = 'ACCEPTED', // alokacje zatwierdzone
  FINALIZED = 'FINALIZED', // po eksporcie
  CANCELLED = 'CANCELLED', // anulowane
  COMPLAINED = 'COMPLAINED', // do reklamacji
}
